export const fftDocs = {
  name: 'fft',
  category: 'Matrix',
  syntax: [
    'fft(x)'
  ],
  description: 'Calculate N-dimensional Fourier transform',
  examples: [
    'fft([[1, 0], [1, 0]])'
  ],
  seealso: [
    'ifft'
  ]
}
